import request from '@/utils/request'

//  修改用户名称|密码
export const editNicknamePassword = (formData) => {
    return request.put(`/admin/nicknamePassword?nickname=${formData.nickname}&password=${formData.password}&passwordOld=${formData.passwordOld}`)
}
